//tour1,tour3 - My quiz
//tour2 - Quiz creator modal
//tour4 - Master start live
//tour5 - Master share QR page
//tour6 - Master result
//tour7 - AI generate
//tour8 - Whitelist Section
//tour9 - Shared with me
//tour10 - School Quizzes
//tour11 - Competition Quizzes
//tour12 - Reports
//tour13 - Affiliate/Partner
//tour14 - Manage School
//tour15 - Approval

import { currentUser } from '@/lib/user'

export default {

    data() {
        return {}
    },

    computed: {
        stepTour1() {
            const steps = [
                {
                    title: this.translate("tour_1_title_step_1"),
                    intro: this.translate("tour_1_detail_step_1"),
                },
                {
                    element: "#my-quiz-tab",
                    title: this.translate("tour_1_title_step_2"),
                    intro: this.translate("tour_1_detail_step_2"),
                },
                {
                    element: ".new-quiz-box",
                    title: this.translate("tour_1_title_step_3"),
                    intro: this.translate("tour_1_detail_step_3"),
                },
            ];

            if (currentUser().role === 'teacher_plus') {
                const schoolName = currentUser().school_name

                steps[0] = {
                    title: this.translate("tour_1_title_step_1_teacher_plus"),
                    intro: this.translate("tour_1_detail_step_1_teacher_plus", { schoolName }),
                    tooltipClass: "tour-width-350",
                }
            }

            if (currentUser().role === 'teacher') {
                steps[0] = {
                    title: this.translate("tour_1_title_step_1_teacher_basic"),
                    intro: this.translate("tour_1_detail_step_1_teacher_basic"),
                    tooltipClass: "tour-width-300",
                }
            }

            if (this.isSchoolRoles) {
                const element = steps.find(item => item.element == '#my-quiz-tab')
                element.intro = this.translate("tour_1_detail_step_2_school")
            }

            return steps

        },

        stepTour2() {
            return [
                {
                    title: this.translate("tour_2_title_step_1"),
                    intro: this.translate("tour_2_detail_step_1"),
                },
                {
                    element: "#button-setting-quiz",
                    title: this.translate("tour_2_title_step_2"),
                    intro: this.translate("tour_2_detail_step_2"),
                },
                {
                    element: ".tool-icon",
                    title: this.translate("tour_2_title_step_3"),
                    intro: this.translate("tour_2_detail_step_3"),
                },
                {
                    element: "#button-add-question",
                    title: this.translate("tour_2_title_step_4"),
                    intro: this.translate("tour_2_detail_step_4"),
                },
            ];
        },

        stepTour3() {
            return [
                {
                    element: ".quiz-thumbnail",
                    title: this.translate("tour_3_title_step_1"),
                    intro: this.translate("tour_3_detail_step_1"),
                },
                {

                    element: "#edit-quiz-button-box",
                    title: this.translate("tour_3_title_step_2"),
                    intro: this.translate("tour_3_detail_step_2"),
                },
                {

                    element: "#preview-quiz-button",
                    title: this.translate("tour_3_title_step_3"),
                    intro: this.translate("tour_3_detail_step_3"),
                },
                {

                    element: "#share-quiz-button",
                    title: this.translate("tour_3_title_step_4"),
                    intro: this.translate("tour_3_detail_step_4"),
                },
                {
                    element: "#edit-quiz-item",
                    title: this.translate("tour_3_title_step_5"),
                    intro: this.translate("tour_3_detail_step_5"),
                    position: "right"
                },
            ];
        },

        stepTour4() {
            return [
                {
                    title: this.translate("tour_4_title_step_1"),
                    intro: this.translate("tour_4_detail_step_1"),
                },
                {
                    element: "#join-as-master",
                    title: this.translate("tour_4_title_step_2"),
                    intro: this.translate("tour_4_detail_step_2"),
                },
                {
                    element: "#join-as-player",
                    title: this.translate("tour_4_title_step_3"),
                    intro: this.translate("tour_4_detail_step_3"),
                    position: "top"
                },
                {
                    element: "#limit-player-upgrade",
                    title: this.translate("tour_4_title_step_4"),
                    intro: this.translate("tour_4_detail_step_4"),
                    position: "top"
                },
                {
                    element: "#landing-quiz-settings",
                    title: this.translate("tour_4_title_step_5"),
                    intro: this.translate("tour_4_detail_step_5"),
                },
                {
                    element: "#start-live-btn",
                    title: this.translate("tour_4_title_step_6"),
                    intro: this.translate("tour_4_detail_step_6"),
                }
            ]
        },

        stepTour5() {
            return [
                {
                    element: "#secondary-screen",
                    title: this.translate("tour_5_title_step_1"),
                    intro: this.translate("tour_5_detail_step_1"),
                },
                {
                    element: ".quiz-qrcode-box",
                    title: this.translate("tour_5_title_step_2"),
                    intro: this.translate("tour_5_detail_step_2"),
                    position: "right"
                },
                {
                    element: ".quiz-qrcode-box",
                    title: this.translate("tour_5_title_step_3"),
                    intro: this.translate("tour_5_detail_step_3"),
                    position: "right"
                },
                {
                    element: "#start-live-quiz",
                    title: this.translate("tour_5_title_step_4"),
                    intro: this.translate("tour_5_detail_step_4")
                }
            ]
        },

        stepTour6() {
            return [
                {
                    title: this.translate("tour_6_title_step_1"),
                    intro: this.translate("tour_6_detail_step_1"),
                },
                {
                    element: ".quiz-result-next-button",
                    title: this.translate("tour_6_title_step_2"),
                    intro: this.translate("tour_6_detail_step_2"),
                },
                {
                    element: "#show-choice-button",
                    title: this.translate("tour_6_title_step_3"),
                    intro: this.translate("tour_6_detail_step_3"),
                },
                {
                    element: "#show-correct-button",
                    title: this.translate("tour_6_title_step_4"),
                    intro: this.translate("tour_6_detail_step_4"),
                },
                {
                    element: "#result-secondary-screen",
                    title: this.translate("tour_6_title_step_5"),
                    intro: this.translate("tour_6_detail_step_5"),
                }
            ]
        },

        stepTour7() {
            return [
                {
                    element: "#box-topic",
                    title: this.translate("tour_7_title_step_1"),
                    intro: this.translate("tour_7_detail_step_1"),
                },
                {
                    element: "#box-number-of-questions",
                    title: this.translate("tour_7_title_step_2"),
                    intro: this.translate("tour_7_detail_step_2"),
                },
                {
                    element: "#box-number-of-answer",
                    title: this.translate("tour_7_title_step_3"),
                    intro: this.translate("tour_7_detail_step_3"),
                },
                {
                    element: "#box-language",
                    title: this.translate("tour_7_title_step_4"),
                    intro: this.translate("tour_7_detail_step_4"),
                },
                {
                    element: "#box-difficult-level",
                    title: this.translate("tour_7_title_step_5"),
                    intro: this.translate("tour_7_detail_step_5"),
                },
                {
                    element: "#box-age",
                    title: this.translate("tour_7_title_step_6"),
                    intro: this.translate("tour_7_detail_step_6"),
                }
            ]
        },

        stepTour8() {
            return [
                {
                    title: this.translate("tour_8_title_step_1"),
                    intro: this.translate("tour_8_detail_step_1"),
                    tooltipClass: "tour-width-350",
                }
            ]
        },

        stepTour9() {
            return [
                {
                    title: this.translate("tour_9_title_step_1"),
                    intro: this.translate("tour_9_detail_step_1"),
                    tooltipClass: "tour-width-350",
                }
            ]
        },

        stepTour10() {
            return [
                {
                    title: this.translate("tour_10_title_step_1"),
                    intro: this.translate("tour_10_detail_step_1"),
                    tooltipClass: "tour-width-350",
                }
            ]
        },

        stepTour11() {
            return [
                {
                    title: this.translate("tour_11_title_step_1"),
                    intro: this.translate("tour_11_detail_step_1"),
                    tooltipClass: "tour-width-350",
                }
            ]
        },

        stepTour12() {
            return [
                {
                    title: this.translate("tour_12_title_step_1"),
                    intro: this.translate("tour_12_detail_step_1"),
                    tooltipClass: "tour-width-350",
                }
            ]
        },

        stepTour13() {
            return [
                {
                    title: this.translate("tour_13_title_step_1"),
                    intro: this.translate("tour_13_detail_step_1"),
                    tooltipClass: "tour-width-350",
                }
            ]
        },

        stepTour14() {
            return [
                {
                    title: this.translate("tour_14_title_step_1"),
                    intro: this.translate("tour_14_detail_step_1"),
                    tooltipClass: "tour-width-350",
                }
            ]
        },

        stepTour15() {
            return [
                {
                    title: this.translate("tour_15_title_step_1"),
                    intro: this.translate("tour_15_detail_step_1"),
                    tooltipClass: "tour-width-350",
                }
            ]
        },

        hintsQuizThumbnail() {
            return {
                groupQuizThumbnail: [
                    {
                        hint: this.translate("hint_thumbnail_start_live"),
                        element: "#start-live",
                        name: "hint_quiz_thumbnail_1",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-left-25",
                    },
                    {
                        hint: this.translate("hint_thumbnail_start_quiz"),
                        element: "#start-single",
                        name: "hint_quiz_thumbnail_2",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-left-25",
                    },
                    {
                        hint: this.translate("hint_thumbnail_share_with_report"),
                        element: "#share-with-report",
                        name: "hint_quiz_thumbnail_3",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-left-25",
                    },
                    {
                        hint: this.translate("hint_thumbnail_embed_quiz"),
                        element: "#embed-quiz",
                        name: "hint_quiz_thumbnail_4",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-left-25",
                    },
                    {
                        hint: this.translate("hint_thumbnail_share_with_user"),
                        element: "#share-with-user",
                        name: "hint_quiz_thumbnail_5",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-left-25",
                    },
                    {
                        hint: this.translate("hint_thumbnail_start_live_teams"),
                        element: "#start-live-teams",
                        name: "hint_quiz_thumbnail_6",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-left-25",
                    },
                ],
            }
        },

        hintsQuestionList() {
            return {
                groupQuestionList: [
                    {
                        hint: this.translate("hint_question_list_robot"),
                        name: "hint_question_list_1",
                        hintPosition: "top-right",
                        element: "#button-robot-question",
                        extraClass: "hint-margin-top-5, hint-margin-left-10"
                    },
                    {
                        hint: this.translate("hint_question_list_checkbox"),
                        name: "hint_question_list_2",
                        hintPosition: "bottom-right",
                        element: ".intro-checkbox",
                        extraClass: "hint-margin-top-5, hint-margin-left-25"
                    },
                    {
                        hint: this.translate("hint_question_list_dragg"),
                        name: "hint_question_list_3",
                        hintPosition: "top-right",
                        element: ".draggable-box",
                        extraClass: "hint-margin-top-20, hint-margin-left-30"
                    },
                    {
                        hint: this.translate("hint_question_list_crown"),
                        name: "hint_question_list_4",
                        hintPosition: "top-right",
                        element: ".crown-icon",
                        extraClass: "hint-margin-top-5, hint-margin-left-25"
                    }
                ],
            }
        },

        hintsCreateQuestion() {
            return {
                groupCreateQuestion: [
                    {
                        hint: this.translate("hint_create_question_question_type"),
                        element: "#question-type-select",
                        name: "hint_create_question_1",
                        hintPosition: "top-right",
                        tooltipClass: "tooltip-question-type",
                        extraClass: "hint-margin-top-10, hint-margin-left-10",
                    },
                    {
                        hint: this.translate("hint_create_question_answers_required"),
                        element: "#label-answers-required",
                        name: "hint_create_question_2",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-top-10, hint-margin-left-10",
                    },
                    {
                        hint: this.translate("hint_create_question_mandatory"),
                        element: "#mandatory-checkbox",
                        name: "hint_create_question_3",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-left-25",
                    },
                    {
                        hint: this.translate("hint_create_question_question_status"),
                        element: "#label-toggle-question-status",
                        name: "hint_create_question_4",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-left-25",
                    },
                    {
                        hint: this.translate("hint_question_list_crown"),
                        element: "#crown-icon-header",
                        name: "hint_create_question_5",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-left-25",
                    },
                ],
            }
        },

        hintsQuizSettings() {
            return {
                groupQuizSettings: [
                    {
                        hint: this.translate("hint_quiz_setting_number_of_question"),
                        element: "#number-of-question-id",
                        name: "hint_quiz_settings_1",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-left-25",
                    },
                    {
                        hint: this.translate("hint_quiz_setting_random_question"),
                        element: "#random-question-id",
                        name: "hint_quiz_settings_2",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-left-25",
                    },
                    {
                        hint: this.translate("hint_quiz_setting_description"),
                        element: "#description-id",
                        name: "hint_quiz_settings_3",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-left-25",
                    },
                    {
                        hint: this.translate("hint_quiz_setting_custom_message"),
                        element: "#custom-message-id",
                        name: "hint_quiz_settings_4",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-left-25",
                    },
                ],
            }
        },

        hintsThemeSettings() {
            return {
                groupThemeSettings: [
                    {
                        hint: this.translate("hint_theme_setting_quiz_image"),
                        element: "#quiz-image",
                        name: "hint_theme_settings_1",
                        hintPosition: "top-right",
                    },
                    {
                        hint: this.translate("hint_theme_setting_background_type"),
                        element: "#select-background-type",
                        name: "hint_theme_settings_2",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-top-10, hint-margin-left-10",
                    },
                ],
            }
        },

        hintsLiveSettings() {
            return {
                groupLiveSettings: [
                    {
                        hint: this.translate("hint_live_setting_delay_choice"),
                        element: "#delay-choice",
                        name: "hint_live_settings_1",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-top-15"
                    },
                    {
                        hint: this.translate("hint_live_setting_time_limit"),
                        element: "#time-limit",
                        name: "hint_live_settings_2",
                        hintPosition: "top-right",
                        extraClass: "hint-margin-left-25",
                    },
                ],
            }
        }
    },

    methods: {
        translate(key, variables) {
            if (!this.$i18n && typeof this.$i18n == 'undefined') {
                return window.translate(key, variables)
            }

            return this.$t(key, variables)
        },

        openSlideFromHint() {
            window.openSlideBySlug = e => {
                const href = e.getAttribute('href')

                if (!href || !href.startsWith('#')) {
                    return
                }

                const slug = href.replace('#', '')

                const openPageEvent = new CustomEvent('page-open', {
                    detail: {
                        slug: slug
                    }
                })

                window.dispatchEvent(openPageEvent)

                const tooltip = document.querySelector('.introjs-tooltip')
                if (tooltip) {
                    tooltip.style.display = 'none'
                }
            }
        }
    }
};
